import { Grid, IconButton, Typography } from "@mui/material"
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { CardsStatics, LightTooltip } from "src/Pages/components/CardsStatics"
import { VisibilityIcon } from "src/Pages/components/Icons/Icons";
import moment from "moment";

import { useNavigate } from "react-router-dom";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { UrlConfig } from "src/shared/Utils/paths";
import { valuesDefaultFilterBordero } from "src/Contexts/Lancamentos/Contrato/valuesDefaultInputsContratos/ValueDefaultInputContratos";

export const CardInstallments = () => {
  const { valuesCardsInstallmentsHome, filterHome } = useMetricsContext();
  const { setValuesFilterBordero, valuesFilterBordero } = useContextContrato();

  const navigate = useNavigate();

  const handleRedirectInstallments = (type: "RECEIVED" | "EXPIRED" | "PENDING") => {
    setValuesFilterBordero(valuesDefaultFilterBordero);

    if (type === "RECEIVED") {
      setValuesFilterBordero((prevValue) => ({
        ...prevValue,
        installmentReceipt: "TRUE",
        startDateReceipt: filterHome.startDate,
        endDateReceipt: filterHome.endDate,
      }));
    }
    if (type === "PENDING") {
      setValuesFilterBordero((prevValue) => ({
        ...prevValue,
        installmentReceipt: "FALSE",
        startDueDate: moment(filterHome.startDate).isAfter(moment()) ? filterHome.startDate : moment().format("YYYY-MM-DD"),
        endDueDate: filterHome.endDate,
      }));
    }
    if (type === "EXPIRED") {
      setValuesFilterBordero((prevValue) => ({
        ...prevValue,
        installmentReceipt: "FALSE",
        startDueDate: filterHome.startDate,
        endDueDate: moment(filterHome.endDate).isBefore(moment()) ? filterHome.endDate : moment().subtract(1, "day").format("YYYY-MM-DD")
      }));
    }

    navigate(`${UrlConfig.lancamentos.parcelas.url}`);
  };

  return (
    <>
      <Grid item md={12} xs={12}>
        <Typography fontWeight="bold" color="text.secondary" sx={{ mb: "12px" }}>
          Parcelas ({valuesCardsInstallmentsHome?.total || "0"})
        </Typography>
      </Grid>

      <Grid container item spacing={2} md={12} xs={12} >
        <Grid item md={4} xs={12}>
          <CardsStatics
            data={{ name: "Recebidas", value1: { value: valuesCardsInstallmentsHome?.installmentsReceived.total.toString() || "0" }, }}
            small
            button={
              <LightTooltip title="Ver parcelas recebidas">
                <IconButton size="small" onClick={() => handleRedirectInstallments("RECEIVED")}>
                  <VisibilityIcon color="primary" sx={{ fontSize: "16px" }} />
                </IconButton>
              </LightTooltip>
            }
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <CardsStatics
            data={{ name: "Pendentes", value1: { value: valuesCardsInstallmentsHome?.installmentsPending.total.toString() || "0" }, }}
            small
            button={
              <LightTooltip title="Ver parcelas pendentes">
                <IconButton size="small" onClick={() => handleRedirectInstallments("PENDING")}>
                  <VisibilityIcon color="primary" sx={{ fontSize: "16px" }} />
                </IconButton>
              </LightTooltip>
            }
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <CardsStatics
            data={{ name: "Vencidas", value1: { value: valuesCardsInstallmentsHome?.installmentsExpired.total.toString() || "0" }, }}
            small
            button={
              <LightTooltip title="Ver parcelas vencidas">
                <IconButton size="small" onClick={() => handleRedirectInstallments("EXPIRED")}>
                  <VisibilityIcon color="primary" sx={{ fontSize: "16px" }} />
                </IconButton>
              </LightTooltip>
            }
          />
        </Grid>
      </Grid>
    </>
  )
}